<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-mpf">
    <header class="tpl-mpf__hero">
      <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-mpf__logo" />
      <h1 class="tpl-mpf__hero-title">{{ quiz.title }}</h1>
      <p v-if="quiz.sub_title" class="tpl-mpf__hero-sub">{{ quiz.sub_title }}</p>
    </header>

    <div class="tpl-mpf__banner">
      <div class="tpl-mpf__banner-inner"><slot name="banner"></slot></div>
    </div>

    <main class="tpl-mpf__main">
      <slot />
    </main>

    <footer class="tpl-mpf__footer">
      <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank">
        {{ quiz.privacy_text || 'Privacy Policy' }}
      </a>
      <p v-if="quiz.legal_name" class="tpl-mpf__footer-legal">
        {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
      </p>
      <p v-if="quiz.disclaimer" class="tpl-mpf__footer-disclaimer">{{ quiz.disclaimer }}</p>
    </footer>
  </div>
</template>
